module.exports = "https://cdn.thelire.com/ins/resource/lh_store_vip_drop.78d6d3884c9d2fef6065cfaf86f52f94.png";